import { render, staticRenderFns } from "./idolSaleMachineBlackUserList.vue?vue&type=template&id=1033dca2&scoped=true"
import script from "./idolSaleMachineBlackUserList.vue?vue&type=script&lang=ts"
export * from "./idolSaleMachineBlackUserList.vue?vue&type=script&lang=ts"
import style0 from "./idolSaleMachineBlackUserList.vue?vue&type=style&index=0&id=1033dca2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033dca2",
  null
  
)

export default component.exports